import { useEffect, useState } from "react";

const getTimeParts = (targetDate) => {
  const diff = Math.max(0, new Date(targetDate).getTime() - Date.now());
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return { days, hours, minutes, seconds, done: diff <= 0 };
};

export const SmartlinkCountdown = ({ targetDate }) => {
  const [parts, setParts] = useState(() => getTimeParts(targetDate));

  useEffect(() => {
    const interval = setInterval(() => setParts(getTimeParts(targetDate)), 1000);
    return () => clearInterval(interval);
  }, [targetDate]);

  if (parts.done) return null;

  const units = [
    { value: parts.days, label: "D" },
    { value: parts.hours, label: "H" },
    { value: parts.minutes, label: "M" },
    { value: parts.seconds, label: "S" },
  ];

  return (
    <div className="flex items-center gap-2" data-testid="smartlink-countdown">
      {units.map((u) => (
        <div key={u.label} className="flex flex-col items-center bg-white/10 rounded-lg px-2.5 py-1.5 min-w-[46px]">
          <span className="text-base font-bold text-white tabular-nums leading-none">{String(u.value).padStart(2, "0")}</span>
          <span className="text-[9px] font-semibold text-neutral-400 uppercase tracking-wide mt-0.5">{u.label}</span>
        </div>
      ))}
    </div>
  );
};
